import React from 'react';
import TopAndBottomBar from '../components/TopAndBottomBar';
import ContentWrapper from '../components/ContentWrapper';
import Video from '../components/Content/Video'
import CourseActionsBar from '../components/courseContent/CourseActionsBar';
import styled from 'styled-components'

const Wrapper = styled.div`
    height: calc(100% - 224px);
    overflow: hidden;
    background-color: #f0f0f7;
    @media (max-width: 1050px) {
        height: calc(100% - 112px)
    }
`

const Cronograma = props => {
  const { cursoId, trails, open, apresentacao, ...rest } = props //eslint-disable-line
  const content = { codigo: apresentacao, titulo: 'Apresentação da aula' }
  return (
    <>
      <ContentWrapper open={open}>
        <Wrapper>
          <Video content={content} ></Video>
        </Wrapper>
      </ContentWrapper>
      <TopAndBottomBar open={open} bottomBar >
          <CourseActionsBar content={content} presentation={true} cursoId={cursoId} trails={trails} />
      </TopAndBottomBar>
    </>
    )
}
export default Cronograma;